<template lang="pug">
  #team-list
    WtTile(class="is-paddingless" :col="12")
      WtTile(:is-loading="processing" :col="12" vertical)
        WtEntityTable(
          title="Existing Teams"
          :data="_.get(teamsResponseObject, 'data', [])"
          :pagination-object="teamsResponseObject.pagination"
          :fetch-action="fetchAction"
          default-sort-field="name"
          default-sort-direction="asc"
          empty-message="No teams exist in this program yet."
          enable-search
          @search="$emit('search', $event)"
          searchPlaceholder="Search by team name..."
        )
          BTableColumn(field="name" label="Team Name" sortable v-slot="column" width="auto" cell-class="has-text-hover")
            WtRouterLink(
              to="Team"
              :params="{ teamId: column.row.teamNameURL}"
              type="table"
            )
              WtTableCellLongText(:text="column.row.name")

          BTableColumn(field="size" label="Team Size" sortable v-slot="column" width="auto")
            | {{ column.row.numMembers }}/{{ column.row.maxMembers }}
          BTableColumn(v-slot="column" width="auto" cell-class="is-paddingless")
            .is-flex-desktop-only
              WtButton(
                isText
                bold
                :disabled="processing"
                @click.native="navigateToEditTeam(column.row.id)"
              ) Edit
              WtButton(
                isText
                bold
                color="grey"
                :disabled="processing"
                @click.native="deleteTeamWrapper(column.row.id)"
              ) Delete

    .buttons.team-list__actions.mt-5
      WtButton(
        bold
        color="grey"
        size="medium"
        outlined
        :isRouterLink="false"
        :disabled="processing || !teamsLength"
        :loading="removingMembers"
        @click.native="removeAllMembersModal()"
      ) Remove all Members
      WtButton(
        bold
        color="grey"
        size="medium"
        outlined
        :isRouterLink="false"
        :disabled="processing || !teamsLength"
        @click.native="deleteAllTeamsModal()"
      ) Delete all Teams

</template>

<script>
import { mapActions, mapGetters } from "vuex";
import tablePropsMixin from "@/mixins/tablePropsMixin";
import WtEntityTable from "@@/WtEntityTable/WtEntityTable";
import WtButton from "@@/WtButton/WtButton";
import WtTile from "@@/WtTile/WtTile";
import WtTableCellLongText from "@@/WtTableCellLongText/WtTableCellLongText";
import WtRouterLink from "@@/WtRouterLink/WtRouterLink";

export default {
  name: "TeamList",

  components: {
    WtEntityTable,
    WtButton,
    WtTile,
    WtTableCellLongText,
    WtRouterLink
  },

  mixins: [tablePropsMixin],

  props: {
    teamsResponseObject: {
      type: Object,
      required: true
    },

    fetchAction: {
      type: Function,
      required: true
    }
  },

  data() {
    return {
      processing: false,
      removingMembers: false
    };
  },

  computed: {
    ...mapGetters("program", ["programTeamsLoaded"]),

    teamsLength() {
      return this._.get(this.teamsResponseObject, "pagination.total", 0);
    }
  },

  mounted() {
    if (!this.programTeamsLoaded) this.fetchProgramTeams();
  },

  methods: {
    ...mapActions("program", ["fetchProgramTeams"]),
    ...mapActions("teams", ["deleteTeam", "deleteAllTeams"]),
    ...mapActions(["snackBar"]),

    navigateToEditTeam(teamId) {
      this.$router.push({
        name: "TeamCenterSettingsTeamEdit",
        params: {
          teamId
        }
      });
    },

    deleteTeamWrapper(teamId) {
      this.$buefy.dialog.confirm({
        title: "Delete Team",
        confirmText: "Confirm",
        type: "is-danger",
        hasIcon: true,
        message:
          "Are you sure? Members will no longer have access to this team and existing team challenges will be affected. Data will no longer be available for this team, so be sure to download team data before deleting. This action can't be reversed.",
        onConfirm: async () => {
          this.processing = true;
          await this.deleteTeam(teamId);
          this.processing = false;
        }
      });
    },

    removeAllMembersModal() {
      this.$buefy.dialog.confirm({
        title: "Remove All Members from Teams",
        confirmText: "Confirm",
        type: "is-danger",
        hasIcon: true,
        message:
          "Are you sure? All members in your program will be removed from their teams. Team challenges currently running will be affected. This action can’t be reversed.",
        onConfirm: async () => {
          this.processing = true;
          this.removingMembers = true;
          await this.axios.post("teams/remove-all-members");
          this.snackBar({
            type: "is-success",
            message: "All members were removed from the teams"
          });
          await this.fetchProgramTeams();
          this.processing = false;
          this.removingMembers = false;
        }
      });
    },

    deleteAllTeamsModal() {
      this.$buefy.dialog.confirm({
        title: "Delete All Teams",
        confirmText: "Confirm",
        type: "is-danger",
        hasIcon: true,
        message: `Deleting all teams is permanent and cannot be undone. Please "Confirm" if you want to delete all teams.`,
        onConfirm: async () => {
          this.processing = true;
          await this.deleteAllTeams();
          await this.fetchProgramTeams();
          this.processing = false;
        }
      });
    }
  }
};
</script>

<style lang="sass" scoped>
#team-list
  .team-list__actions
    display: flex
    justify-content: flex-end
    flex-wrap: wrap
    gap: 1rem
    clear: both

@media screen and (max-width: 768px)
  #team-list
    .team-list__actions
      justify-content: stretch

      > *
        flex: 1 1 100%
        margin: 0
</style>
